import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const axios = require('axios').default;

export default function MuiDialogUpload(props) {

  const [selectedFile, setSelectedFile] = useState();
  const [loading, setLoading] = useState(false);
  const [uploadResults, setUploadResults] = useState({});
  const [failureList, setFailureList] = useState([]);

  function handleSubmission() {
    const data = new FormData()
    data.append('file', selectedFile)
    let url = process.env.REACT_APP_API_SERVER + "/upload";

    setLoading(true)

    axios.post(url, data, { // receive two parameter endpoint url ,form data 
    })
      .then(res => { // then print response status

        setLoading(false)

        let tmp_json = {}
        tmp_json.total_success = res.data.total_accepted
        tmp_json.total_failure = res.data.rejected.length
        setFailureList(res.data.rejected)
        setUploadResults(tmp_json)
        props.setResultsDivClass("")
      })
  }

  const changeHandler = (e) => {
    setSelectedFile(e.target.files[0]);
    props.setFileSelected(true);
  };

  return (
    <div>
      <Dialog
        open={props.showModal}
        onClose={props.handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          UPLOAD CSV FILE
        </DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
            className={props.bodyClass}
          >

            <div>
              <div>
                <input type="file" name="file" accept=".csv" onChange={changeHandler} />
              </div>
              <div style={{height: "20px"}}></div>
              <div>
                <LoadingButton
                  loading = {loading}
                  loadingPosition="start"
                  variant="contained"
                  startIcon={<UploadFileIcon/>}
                  color="info"
                  disabled={!props.fileSelected}
                  onClick={handleSubmission}
                >
                  Upload
                </LoadingButton>
              </div>

              <div className={props.resultsDivClass}>

                <table>
                  <tr><td colspan="2"><div style={{height: "20px"}}></div></td></tr>
                  <tr>
                    <td className="f_bold">Records Import Success: </td>
                    <td>{uploadResults.total_success}</td>
                  </tr>
                  <tr>
                    <td className="f_bold">Records Import Failure: </td>
                    <td>{uploadResults.total_failure}</td>                    
                  </tr>
                  <tr><td colspan="2"><div style={{ height: "5px" }}></div></td></tr>
                  <tr>
                    <td colspan="2">
                      {
                        failureList.map(rec => {
                          return <div>{rec.room_id}</div>
                        })
                      }
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
